

export const GLOBAL_FONTS = [
	{label: 'Default', value: 'default'},
	{label: 'Arial', value: 'Arial, sans-serif'},
	{label: 'Helvatica', value: 'Helvetica, sans-serif'},
	{label: 'Gill Sans', value: 'Gill Sans, sans-serif'},
	{label: 'Montserrat', value: 'Montserrat, sans-serif'},
	{label: 'Raleway', value: 'Raleway, sans-serif'},

	{label: 'Times', value: 'Times, serif'},
	{label: 'Times New Roman', value: 'Times New Roman, serif'},
	{label: 'Palatino', value: 'Palatino, serif'},
	{label: 'Bookman', value: 'Bookman, serif'},

	{label: 'Andale Mono', value: 'Andale Mono, monospace'},
	{label: 'Courier New', value: 'Courier New, monospace'},
	{label: 'Courier', value: 'Courier, monospace'},

	{label: 'Comic Sans', value: 'Comic Sans, Comic Sans MS, cursive'},
	{label: 'Zapf Chancery', value: 'Zapf Chancery, cursive'},
	{label: 'Coronetscript', value: 'Coronetscript, cursive'},
	{label: 'Florence', value: 'Florence, cursive'},
	{label: 'Parkavenue', value: 'Parkavenue, cursive'},

	{label: 'Impact', value: 'Impact, fantasy'},
	{label: 'Arnoldboecklin', value: 'Arnoldboecklin, fantasy'},
	{label: 'Oldtown', value: 'Oldtown, fantasy'},
	{label: 'Blippo', value: 'Blippo, fantasy'}
]